module.exports = __webpack_public_path__ + "media/images/logo-f473947a97d9d8cb3e3b7d5bc78c2543.png";